// Дата-хелперы виджета. Всюду ISO YYYY-MM-DD; «сегодня» — по UTC, как в сканере и API.

export const MONTHS = [
  "Январь",
  "Февраль",
  "Март",
  "Апрель",
  "Май",
  "Июнь",
  "Июль",
  "Август",
  "Сентябрь",
  "Октябрь",
  "Ноябрь",
  "Декабрь",
];
const MONTHS_GEN = [
  "января",
  "февраля",
  "марта",
  "апреля",
  "мая",
  "июня",
  "июля",
  "августа",
  "сентября",
  "октября",
  "ноября",
  "декабря",
];
const MONTHS_SHORT = [
  "янв.",
  "февр.",
  "марта",
  "апр.",
  "мая",
  "июня",
  "июля",
  "авг.",
  "сент.",
  "окт.",
  "нояб.",
  "дек.",
];
export const DOW = ["пн", "вт", "ср", "чт", "пт", "сб", "вс"];
// getDay(): 0 = воскресенье
const WD = ["вс", "пн", "вт", "ср", "чт", "пт", "сб"];

export function iso(y, monthIndex, d) {
  return `${y}-${String(monthIndex + 1).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
}

export function todayIso(now = new Date()) {
  return now.toISOString().slice(0, 10);
}

const parts = (s) => s.split("-").map(Number);

export function addDays(s, n) {
  const [y, m, d] = parts(s);
  const dt = new Date(Date.UTC(y, m - 1, d + n));
  return dt.toISOString().slice(0, 10);
}

export function diffNights(a, b) {
  return Math.round((Date.parse(`${b}T00:00:00Z`) - Date.parse(`${a}T00:00:00Z`)) / 864e5);
}

export function plural(n, one, few, many) {
  const m = Math.abs(n) % 100;
  const d = m % 10;
  if (m > 10 && m < 20) return many;
  if (d > 1 && d < 5) return few;
  if (d === 1) return one;
  return many;
}

export const nightsWord = (n) => plural(n, "ночь", "ночи", "ночей");
export const adultsWord = (n) => plural(n, "взрослый", "взрослых", "взрослых");
export const childrenWord = (n) => plural(n, "ребёнок", "ребёнка", "детей");
export const roomsWord = (n) => plural(n, "номер", "номера", "номеров");
export const reviewsWord = (n) => plural(n, "отзыв", "отзыва", "отзывов");

// «10 сент.» — для чипа дат и сайдбара
export function humanShort(s) {
  const [, m, d] = parts(s);
  return `${d} ${MONTHS_SHORT[m - 1]}`;
}

// «пт, 23 окт» — чипы календаря (T37)
export function humanChip(s) {
  const [y, m, d] = parts(s);
  const wd = WD[new Date(Date.UTC(y, m - 1, d)).getUTCDay()];
  return `${wd}, ${d} ${MONTHS_SHORT[m - 1].replace(/\.$/, "")}`;
}

// «10 сентября» — короткие подсказки календаря (T37)
export function humanDay(s) {
  const [, m, d] = parts(s);
  return `${d} ${MONTHS_GEN[m - 1]}`;
}

// «чт, 10 сентября» — для aria-label и подсказок
export function humanLong(s) {
  const [y, m, d] = parts(s);
  const dt = new Date(Date.UTC(y, m - 1, d));
  return `${WD[dt.getUTCDay()]}, ${d} ${MONTHS_GEN[m - 1]}`;
}

// «10–23 сентября» / «28 сентября – 3 октября» / «30 декабря 2026 – 4 января 2027» —
// диапазон дат карточки-итога оформления (T6)
export function fmtDateRange(from, to) {
  const [fy, fm, fd] = parts(from);
  const [ty, tm, td] = parts(to);
  const sameYear = fy === ty;
  if (sameYear && fm === tm) return `${fd}–${td} ${MONTHS_GEN[fm - 1]}`;
  const left = `${fd} ${MONTHS_GEN[fm - 1]}${sameYear ? "" : ` ${fy}`}`;
  const right = `${td} ${MONTHS_GEN[tm - 1]}${sameYear ? "" : ` ${ty}`}`;
  return `${left} – ${right}`;
}

// «Чт» — день недели с заглавной, для строк заезда/выезда в сайдбаре
export function weekdayShort(s) {
  const [y, m, d] = parts(s);
  const w = WD[new Date(Date.UTC(y, m - 1, d)).getUTCDay()];
  return w[0].toUpperCase() + w.slice(1);
}

export const monthLabel = ([y, m]) => `${MONTHS[m]} ${y}`;

// Список месяцев [год, индекс] от from до to включительно
export function monthListBetween(fromIso, toIso) {
  const [fy, fm] = parts(fromIso);
  const [ty, tm] = parts(toIso);
  const out = [];
  let y = fy;
  let m = fm - 1;
  while (y < ty || (y === ty && m <= tm - 1)) {
    out.push([y, m]);
    m += 1;
    if (m > 11) {
      m = 0;
      y += 1;
    }
  }
  return out;
}

// Сетка месяца: shift — пустых ячеек до 1-го числа (понедельник — первый), days — дней в месяце
export function buildMonthGrid(y, monthIndex) {
  const shift = (new Date(Date.UTC(y, monthIndex, 1)).getUTCDay() + 6) % 7;
  const days = new Date(Date.UTC(y, monthIndex + 1, 0)).getUTCDate();
  return { shift, days };
}
